module.exports = __webpack_public_path__ + "static/media/de.861f6105.svg";